import * as React from "react";

const ArrowUp: React.FC = () => {
    return <svg width="14px" height="16px" viewBox="0 0 14 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-89.000000, -359.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(10.000000, 129.000000)">
                    <polygon points="6 3.4 6 16 8 16 8 3.4 12.7 8.3 14 7 7 0 0 7 1.3 8.3"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(ArrowUp);
